module.exports = __webpack_public_path__ + "static/media/calendar_client_blue.60c39c67.svg";